import { createContext } from 'react';
import type { StoredDesign } from '@/services/storage';
import type { LibraryTab } from '@/features/library/components/LibraryTabs';
import type { CommunityFolder } from '@/types';

export interface LibraryContextValue {
  selectedDesign: StoredDesign | null;
  activeSideBlob: Blob | null;
  selectDesign: (design: StoredDesign | null) => void;
  activeTab: LibraryTab;
  setActiveTab: (tab: LibraryTab) => void;
  // Community state
  selectedFolder: CommunityFolder | null;
  selectFolder: (folder: CommunityFolder | null) => void;
  viewingFolderDetail: boolean;
  setViewingFolderDetail: (viewing: boolean) => void;
}

export const LibraryContext = createContext<LibraryContextValue | null>(null);
